import {
  ProfileEmployeeLocationEmployeesLocationFragment,
  ProfileEmployeeLocationFragment,
} from 'generated/resources/graphql'

import { Box, List, Text } from '@factorialco/deprecated-design-system'

import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'

import EmployeeWorkplacesListItem from 'modules/profile/components/Workplaces/EmployeeWorkplacesListItem'

interface Props {
  employeeId: number
  accessId: number
  employeeLocations: ProfileEmployeeLocationEmployeesLocationFragment[]
  companyLocations: ProfileEmployeeLocationFragment[]
  defaultLocationId: number | null
  canAssignLocations: boolean
  onDefaultLocationUpdated: (id: number) => void
}

const EmployeeWorkplacesList = ({
  employeeId,
  accessId,
  defaultLocationId,
  employeeLocations,
  companyLocations,
  canAssignLocations,
  onDefaultLocationUpdated,
}: Props) => {
  const {
    has_dev_employee_location_work_area: isEmployeeLocationWorkAreaEnabled,
    loadingFeatures: isFeatureFlagsLoading,
  } = useFeatures(['dev_employee_location_work_area'])

  const defaultLocation =
    defaultLocationId != null
      ? employeeLocations.find((location) => defaultLocationId == location?.location?.id)
      : undefined

  const defaultWorkArea = isEmployeeLocationWorkAreaEnabled
    ? defaultLocation?.employeesLocationWorkAreas?.find((workArea) => workArea.isDefault)
    : undefined

  return (
    <List>
      {defaultLocation && defaultLocation?.location?.id && (
        <EmployeeWorkplacesListItem
          locationName={defaultLocation?.location?.name}
          isLocationDefault
          employeeId={employeeId}
          accessId={accessId}
          locationId={defaultLocation?.location?.id}
          canAssignLocations={canAssignLocations}
          defaultWorkArea={defaultWorkArea}
          onDefaultLocationUpdated={onDefaultLocationUpdated}
          employeeLocations={employeeLocations}
          isEmployeeLocationWorkAreaEnabled={isEmployeeLocationWorkAreaEnabled}
          isFeatureFlagsLoading={isFeatureFlagsLoading}
          companyLocations={companyLocations}
          employeesLocation={defaultLocation}
        />
      )}
      {employeeLocations.map((employeeLocation) => {
        const isLocationDefault = defaultLocation == employeeLocation
        if (isLocationDefault) return
        if (!employeeLocation?.location?.id) return

        const location = employeeLocation?.location

        return (
          <EmployeeWorkplacesListItem
            key={location.id}
            locationName={location.name}
            isLocationDefault={isLocationDefault}
            employeeId={employeeId}
            accessId={accessId}
            locationId={location.id}
            canAssignLocations={canAssignLocations}
            companyLocations={companyLocations}
            employeeLocations={employeeLocations}
            onDefaultLocationUpdated={onDefaultLocationUpdated}
            isEmployeeLocationWorkAreaEnabled={isEmployeeLocationWorkAreaEnabled}
            isFeatureFlagsLoading={isFeatureFlagsLoading}
            employeesLocation={employeeLocation}
          />
        )
      })}

      {employeeLocations.length === 0 && (
        <List.Item>
          <Box
            flexDirection="row"
            alignItems="center"
            width="full"
            justifyContent="spaceBetween"
            gap="s24"
          >
            <Text color="grey800" weight="normal" size="200">
              {i18n.t('employee_form.workplaces.no_workplaces')}
            </Text>
          </Box>
        </List.Item>
      )}
    </List>
  )
}

export default EmployeeWorkplacesList
